// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "5d59d287-dirty",
    "hash": "5d59d287",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "5d59d287-dirty",
    "semverString": null,
    "devVersion": "0.81.0",
    "branch": null
};
/* tslint:enable */
